import React from "react";
import LegalLayout from "./LegalLayout";
import { BRAND } from "@/lib/api";

export default function Terms() {
  return (
    <LegalLayout
      title="Terms of Service"
      path="/terms"
      subtitle="The terms that apply when you use the True North Maintenance website, submit a request, or engage us to do work."
      lastUpdated="13 May 2026"
    >
      <p>
        These Terms govern your use of the True North Maintenance website
        (truenorthmaintenance.com.au) and our maintenance, repair and cleaning
        services. By using our site or engaging us to do work, you agree to these Terms.
        If you do not agree, please do not use the site.
      </p>

      <h2>About us</h2>
      <p>
        True North Maintenance operates from Albury / Wodonga, Australia, servicing
        properties within a 60 km radius. Contact us at <a href={`mailto:${BRAND.email}`}>{BRAND.email}</a> or {BRAND.phone}.
      </p>

      <h2>Use of the website</h2>
      <ul>
        <li>You agree to use this website only for lawful purposes and in a way that does not infringe anyone else's rights.</li>
        <li>You must not attempt to gain unauthorised access to the admin area, interfere with the site's operation, or scrape content for commercial use without our written permission.</li>
        <li>All content on this site — text, images, the logo, photography of completed jobs — is owned by True North Maintenance unless otherwise stated, and is protected by copyright.</li>
      </ul>

      <h2>Quotes &amp; bookings</h2>
      <ul>
        <li>A quote submitted via this website is a <strong>request for service</strong>, not a confirmed booking. We will contact you to confirm scope, pricing and timing before work commences.</li>
        <li>Written quotes are valid for 30 days unless otherwise stated.</li>
        <li>We do not charge a deposit for standard maintenance jobs. Larger jobs may require a materials deposit, which will be agreed in writing.</li>
        <li>We aim to get back to you shortly on every quote request we receive.</li>
      </ul>

      <h2>Workmanship guarantee</h2>
      <p>
        We guarantee our workmanship on every job. If you're not happy with the work, contact
        us within fourteen (14) days and we will come back and make it right at no extra cost.
        This guarantee covers our labour. Defects in materials are subject to the manufacturer's warranty.
      </p>

      <h2>Payment</h2>
      <ul>
        <li>Invoices are sent on completion of the job and are payable within seven (7) days unless otherwise agreed.</li>
        <li>We accept bank transfer, cash and major credit cards (where supported).</li>
        <li>Overdue invoices may accrue interest at the RBA cash rate + 4% per annum.</li>
      </ul>

      <h2>Cancellations</h2>
      <ul>
        <li>You may cancel a booked job at no cost up to 24 hours before the scheduled start time.</li>
        <li>Cancellations within 24 hours may attract a call-out fee equivalent to one hour of labour.</li>
        <li>If we need to reschedule due to weather, illness or other unforeseen circumstances, we will give you as much notice as possible and reschedule at no extra cost.</li>
      </ul>

      <h2>Limitations of liability</h2>
      <p>
        To the extent permitted by law:
      </p>
      <ul>
        <li>We are not liable for any indirect, consequential or special loss arising from your use of this website or our services.</li>
        <li>Our total liability for any claim is limited to the amount you paid us for the relevant job.</li>
        <li>Nothing in these Terms limits any rights you have under the <em>Australian Consumer Law</em> (Schedule 2 of the <em>Competition and Consumer Act 2010</em>).</li>
      </ul>

      <h2>Reviews</h2>
      <p>
        Reviews submitted via our website are moderated before publication. We reserve the right to
        decline to publish reviews that contain abusive language, false claims, or content unrelated
        to a job we have done. You retain ownership of the words in your review but grant us a
        non-exclusive licence to publish them on our website and social channels.
      </p>

      <h2>Privacy</h2>
      <p>
        Our handling of your personal information is governed by our <a href="/privacy">Privacy Policy</a>.
      </p>

      <h2>Changes to these terms</h2>
      <p>
        We may update these Terms from time to time. The "last updated" date at the top of this page reflects the most recent change. Continued use of our services after a change constitutes acceptance of the updated Terms.
      </p>

      <h2>Governing law</h2>
      <p>
        These Terms are governed by the laws of New South Wales, Australia. Any disputes will be subject to the exclusive jurisdiction of the courts of New South Wales.
      </p>

      <h2>Contact</h2>
      <p>Questions about these Terms? Contact <a href={`mailto:${BRAND.email}`}>{BRAND.email}</a>.</p>
    </LegalLayout>
  );
}
